'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Collapsible: ()=>Collapsible
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const collapsible_namespaceObject = require("@base-ui-components/react/collapsible");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const Chevron_index_cjs_namespaceObject = require("../SVG/Chevron/index.cjs");
const external_Collapsible_variants_cjs_namespaceObject = require("./Collapsible.variants.cjs");
const DEFAULT_PROPS = {
    panelId: 'collapsible-panel-id-default',
    withTriggerIcon: true,
    triggerIconPosition: 'right',
    flushAligned: false,
    elevated: false,
    triggerPadding: '',
    triggerRoundedDefault: 'rounded-xl'
};
function Collapsible({ children, className, triggerClassName, panelId = DEFAULT_PROPS.panelId, withTriggerIcon = DEFAULT_PROPS.withTriggerIcon, triggerIconPosition = DEFAULT_PROPS.triggerIconPosition, flushAligned = DEFAULT_PROPS.flushAligned, elevated = DEFAULT_PROPS.elevated, heading, collapsedFooter, expandedFooter, triggerPadding = DEFAULT_PROPS.triggerPadding, triggerRoundedDefault = DEFAULT_PROPS.triggerRoundedDefault, ...props }) {
    const { root, elevatedRoot, openElevatedRoot, headingTrigger, elevatedHeadingTrigger, openElevatedHeadingTrigger, panel, footerTrigger, footer } = (0, external_Collapsible_variants_cjs_namespaceObject.collapsibleVariants)({
        ...props,
        flushAligned
    });
    const [uncontrolledOpen, setUncontrolledOpen] = (0, external_react_namespaceObject.useState)(props.defaultOpen || false);
    const isOpen = 'boolean' == typeof props.open ? props.open : uncontrolledOpen;
    const rootClasses = (0, index_cjs_namespaceObject.cn)(isOpen && elevated ? openElevatedRoot() : elevated ? elevatedRoot() : root(), className);
    const elevatedHeadingTriggerClasses = isOpen ? openElevatedHeadingTrigger() : elevatedHeadingTrigger();
    const triggerCustomClassArray = [
        triggerPadding.length > 0 ? triggerPadding : `${!flushAligned ? 'px-4' : 'px-0'} py-3`,
        elevated || flushAligned || !(triggerRoundedDefault.length > 0) ? '' : triggerRoundedDefault
    ];
    const triggerClasses = (0, index_cjs_namespaceObject.cn)(elevated ? elevatedHeadingTriggerClasses : headingTrigger(), triggerCustomClassArray.length > 0 ? triggerCustomClassArray.join(' ') : '', triggerClassName);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(collapsible_namespaceObject.Collapsible.Root, {
        open: isOpen,
        onOpenChange: props.onOpenChange ?? (()=>setUncontrolledOpen(!isOpen)),
        className: rootClasses,
        "data-testid": "base-collapsible-root",
        "data-state": isOpen ? 'open' : 'closed',
        children: [
            /*#__PURE__*/ (0, external_react_namespaceObject.isValidElement)(heading) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(collapsible_namespaceObject.Collapsible.Trigger, {
                render: (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        ...props,
                        onMouseDown: (e)=>e.preventDefault(),
                        "data-testid": "collapsible-trigger",
                        children: [
                            withTriggerIcon && 'left' === triggerIconPosition && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Chevron_index_cjs_namespaceObject.Chevron, {
                                isOpen: isOpen,
                                size: 24
                            }),
                            heading,
                            withTriggerIcon && 'right' === triggerIconPosition && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Chevron_index_cjs_namespaceObject.Chevron, {
                                isOpen: isOpen,
                                size: 24
                            })
                        ]
                    }),
                nativeButton: false,
                className: triggerClasses
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(collapsible_namespaceObject.Collapsible.Panel, {
                className: panel(),
                id: panelId,
                "data-testid": "collapsible-panel",
                children: children
            }),
            /*#__PURE__*/ (0, external_react_namespaceObject.isValidElement)(collapsedFooter) && /*#__PURE__*/ (0, external_react_namespaceObject.isValidElement)(expandedFooter) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(collapsible_namespaceObject.Collapsible.Trigger, {
                className: footerTrigger(),
                onMouseDown: (e)=>e.preventDefault(),
                "data-testid": "collapsible-footer",
                children: [
                    withTriggerIcon && 'left' === triggerIconPosition && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Chevron_index_cjs_namespaceObject.Chevron, {
                        isOpen: isOpen,
                        size: 24
                    }),
                    !isOpen && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: footer(),
                        children: collapsedFooter
                    }),
                    isOpen && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: footer(),
                        children: expandedFooter
                    }),
                    withTriggerIcon && 'right' === triggerIconPosition && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Chevron_index_cjs_namespaceObject.Chevron, {
                        isOpen: isOpen,
                        size: 24
                    })
                ]
            })
        ]
    });
}
exports.Collapsible = __webpack_exports__.Collapsible;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Collapsible"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
